import { StyledScanUrl } from './ScanUrl.styles';
import { ScanIntroSection } from './ScanSections/ScanIntroSection';
import { ScanInputSection } from './ScanSections/ScanInputSection';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { LoadingScanResults } from './ScanSections/LoadingScanResults';
import { useEffect, useState } from 'react';
import { CheckerStatus } from '../AccessibilityChecker.consts';
import { useApiClientSDK } from '@/hooks/useApiClientSDK';
import { ScanUrlProps, ScanUrlType } from './ScanUrl.consts';

export const ScanUrl: React.FC<ScanUrlProps> = ({ type = ScanUrlType.Public }: ScanUrlProps) => {
  const { setStatus, setAccessibilityData } = useAccessibilityCheckerStore();
  const [isLoading, setIsLoading] = useState(false);

  const [{ apiClient, data, loading, error }, runRequest] = useApiClientSDK({ manual: true });

  const postA11yScan = async (websiteUrl: string) => {
    await runRequest(async () => {
      if (type === ScanUrlType.Admin) {
        return apiClient.api.adminA11YScannerControllerStoreV1({ websiteUrl });
      } else {
        return apiClient.api.publicA11YScannerControllerStoreV1({ websiteUrl });
      }
    });
  };

  useEffect(() => {
    if (data) {
      setAccessibilityData(data);
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (loading) {
      setIsLoading(true);
    }
  }, [loading]);

  useEffect(() => {
    if (error) {
      setStatus(CheckerStatus.PRESCAN);
      setIsLoading(false);
    }
  }, [error]);

  return (
    <>
      <StyledScanUrl>
        {isLoading ? (
          <LoadingScanResults />
        ) : (
          <>
            <ScanIntroSection />
            <ScanInputSection onScan={postA11yScan} />
          </>
        )}
      </StyledScanUrl>
    </>
  );
};
